import MomentUtils from '@date-io/moment';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import dayjs from 'dayjs';
import _ from 'lodash';
import moment from 'moment';
import { useState, useEffect, useRef, useCallback } from 'react';
import { CSVLink } from 'react-csv';

import { SpinnerCircular } from 'spinners-react';

import AuthStore from '../../../stores/AuthStore';
import { validateAccessGranted } from '../../../utils/accessGrantedValidator';

import { getPatientNotesData, PatientNotesResponse, PatientNotesSort } from './data/getPatientNotesData';
import ReportPatientNoteRow from './ReportPatientNoteRow';

const ReportPatientNotes = () => {
  const dateParamFormat = 'YYYY-MM-DD HH:mm:ss';
  const [stateControlTimezoneName, setControlTimezoneName] = useState('');
  const [stateControlTimezoneOffset, setControlTimezoneOffset] = useState(0);
  const [stateFromDate, setStateFromDate] = useState(null);
  const [stateToDate, setStateToDate] = useState(null);
  const [reportData, setReportData] = useState<PatientNotesResponse[]>([]);

  const [fetchingReport, setFetchingReport] = useState(false);

  const [searchText, setSearchText] = useState('');

  const [stateExportFileName, setStateExportFileName] = useState('NucleusCareCallsReport_');

  const [stateSortingStyles, setStateSortingStyles] = useState({
    startDateAsc: ' nucleus-icon-inactive hide ',
    startDateDesc: ' nucleus-icon-active ',
  });

  const [sortingMode, setSortingMode] = useState<PatientNotesSort>('NoteDate:desc');

  useEffect(() => {
    async function loadPatientNotesData() {
      if (stateFromDate && stateToDate) {
        const accountId = AuthStore.getUserAccountID();
        setFetchingReport(true);
        const patientNotesData = await getPatientNotesData({ accountId, startDate: stateFromDate, endDate: stateToDate, searchText, sortBy: sortingMode });
        setReportData(patientNotesData);
        setFetchingReport(false);
      }
    }

    loadPatientNotesData();
  }, [stateFromDate, stateToDate, searchText, sortingMode]);

  const handleSortingMode = (tag: PatientNotesSort, tag2: PatientNotesSort) => {
    console.log('handleSortingMode', tag, tag2);

    const object = {
      startDateAsc: ' nucleus-icon-inactive ',
      startDateDesc: ' nucleus-icon-inactive ',
    };
    if (tag === 'NoteDate:asc') {
      object.startDateAsc = ' nucleus-icon-active ';
      object.startDateDesc = ' nucleus-icon-inactive hide ';
    } else if (tag === 'NoteDate:desc') {
      object.startDateAsc = ' nucleus-icon-inactive hide ';
      object.startDateDesc = ' nucleus-icon-active ';
    }
    setStateSortingStyles(object);
    setSortingMode(tag);
  };

  const callDataToExportRef = useRef([]);
  callDataToExportRef.current = [];

  const csvFileHeadersRef = useRef<{ label: string; key: keyof PatientNotesResponse }[]>([]);
  csvFileHeadersRef.current = [
    { label: 'Date & Time', key: 'NoteDate' },
    { label: 'Patient Name', key: 'PatientName' },
    { label: 'Notes', key: 'Note' },
    { label: 'User', key: 'UserName' },
  ];

  useEffect(() => {
    console.log('ReportCalls useEffect');

    validateAccessGranted('/reports/patient-notes');

    const fromDate = dayjs().subtract(7, 'day').toDate();

    const currentDate = dayjs().toDate();

    setControlTimezoneName(new Date().toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ')[2]);

    const currentTimezone = (currentDate.getTimezoneOffset() / 60) * -1;
    setControlTimezoneOffset(currentTimezone);

    setStateFromDate(fromDate);
    setStateToDate(currentDate);
    refreshReport(fromDate, currentDate);
  }, []);

  const onSearchTextChange = useCallback(
    _.debounce(textInput => {
      console.log('onSearchTextChange', textInput.target.value);
      setSearchText(textInput.target.value);
    }, 500),
    [],
  );

  const onFromDateChange = (date, value) => {
    console.log('onFromDateChange', date, value);
    setStateFromDate(value);
    //refreshReport(value, stateToDate);
  };
  const onToDateChange = (date, value) => {
    console.log('onToDateChange', date, value);
    setStateToDate(value);
    //refreshReport(stateFromDate, value);
  };

  const refreshReport = (fromDate, toDate) => {
    console.log('refreshReport', fromDate, toDate);

    const fromDateValue = new Date(fromDate);
    const toDateValue = new Date(toDate);

    fromDateValue.setHours(0);
    fromDateValue.setMinutes(0);
    fromDateValue.setSeconds(0);
    fromDateValue.setHours(fromDateValue.getHours() + stateControlTimezoneOffset * -1);

    toDateValue.setHours(23);
    toDateValue.setMinutes(59);
    toDateValue.setSeconds(0);
    toDateValue.setHours(toDateValue.getHours() + stateControlTimezoneOffset * -1);

    const fromDateParam = moment(fromDateValue).format(dateParamFormat);
    const toDateParam = moment(toDateValue).format(dateParamFormat);

    console.log('PARAM 1', fromDateParam);
    console.log('PARAM 2', toDateParam);

    const fromExportParam = moment(fromDate).format('MM_DD_YYYY');
    const toExportParam = moment(toDate).format('MM_DD_YYYY');

    const exportCSVFileName = 'NucleusCarePatientNotesReport_' + fromExportParam + '_to_' + toExportParam;
    console.log('ExportCSVFileName', exportCSVFileName);
    setStateExportFileName(exportCSVFileName);
  };

  const getTableRows = () => {
    const callsRowArray = [];
    //let array = [];
    if (reportData?.length > 0) {
      const outputArray = [];
      callDataToExportRef.current = [];

      reportData.map((callRecord, key) => {
        outputArray.push(callRecord);
        callsRowArray.push(<ReportPatientNoteRow key={key} data={callRecord}></ReportPatientNoteRow>);
      });
      callDataToExportRef.current = outputArray;

      //console.log("Generated array", outputArray);
      if (callsRowArray && callsRowArray.length > 0) {
        return <tbody>{callsRowArray}</tbody>;
      } else {
        return (
          <tbody className="center-align ">
            <tr style={{ borderBottomStyle: 'none' }}>
              <td colSpan={8} className="center-align ">
                <br />
                <br />
                <br />
                <span className="nucleus-table-header-medium text-gray"> {`There are no patient notes for this search text`} </span>
                <br />
                <br />
                <br />
              </td>
            </tr>
          </tbody>
        );
      }
    }
    return (
      <tbody className="center-align ">
        <tr style={{ borderBottomStyle: 'none' }}>
          <td colSpan={8} className="center-align ">
            <br />
            <br />
            <br />
            <span className="nucleus-table-header-medium text-gray"> {`There are no patient notes for this date range`} </span>
            <br />
            <br />
            <br />
          </td>
        </tr>
      </tbody>
    );
  };
  return (
    <div className="nucleus-hard-container">
      <div className="nucleus-all-scrollable-page-medium no-margin">
        <div>
          <p className="nucleus-tools-page-title">
            <b>Report: Patient Notes</b>
          </p>
        </div>
        <div style={{ marginTop: 0, marginBottom: 0, height: 56 }}>
          <div className="row a-bit-lower left-align">
            <div className="col s9 m7 no-margin">
              <span className="nucleus-tools-page-text-title a-bit-lower">Search &nbsp;&nbsp;&nbsp;</span>
              <input type="text" className="nucleus-input-form-small-left" style={{ width: 500 }} onChange={onSearchTextChange} placeholder={'Patient / Note / User'} />
            </div>

            <div className="col s3 m5 no-margin right-align">
              {fetchingReport && (
                <div style={{ margin: 0, padding: 0, marginTop: 0, marginBottom: 0 }}>
                  <SpinnerCircular color="#2096F3" secondaryColor="rgba(0,0,0,0.16)" size="50" thickness={100} />
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="row left-align">
          <span className="nucleus-tools-page-text-title a-bit-lower" style={{ marginRight: 28 }}>
            From
          </span>
          <div style={{ width: 140, display: 'inline-flex' }}>
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <KeyboardDatePicker
                //ref={fromDateTimePickerRef}
                variant="dialog"
                className="browser-default"
                value={stateFromDate}
                onChange={onFromDateChange}
                onError={console.log}
                onClose={() => {}}
                autoOk={true}
                //minDate={new Date("2018-01-01T00:00")}
                format={'MM/DD/YYYY'}
              />
            </MuiPickersUtilsProvider>
          </div>
          <span className="nucleus-tools-page-text-title a-bit-lower" style={{ marginLeft: 44, marginRight: 16 }}>
            To
          </span>
          <div style={{ width: 140, display: 'inline-flex' }}>
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <KeyboardDatePicker
                //ref={toDateTimePickerRef}
                variant="dialog"
                className="browser-default"
                value={stateToDate}
                onChange={onToDateChange}
                onError={console.log}
                autoOk={true}
                //onClose={()=>{console.log("onClose!");window.focus();}}
                //minDate={new Date("2018-01-01T00:00")}
                minDate={new Date(stateFromDate).setDate(new Date(stateFromDate).getDate() + 1)}
                format={'MM/DD/YYYY'}
              />
            </MuiPickersUtilsProvider>
          </div>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <a
            className="txt-white nucleus-font-small nucleus-submit-btn-small"
            onClick={() => {
              refreshReport(stateFromDate, stateToDate);
            }}
          >
            {' '}
            Refresh{' '}
          </a>
        </div>

        <div className="users-table-pending altoImportantContainer">
          <table className="bordered highlight nucleus-table">
            <thead>
              <tr>
                <th className="table-col-22">
                  <span className="nucleus-table-header-medium ">{'Date & Time'}</span>
                  <a className={'nucleus-font-small ' + stateSortingStyles.startDateDesc} onClick={() => handleSortingMode('NoteDate:asc', 'NoteDate:desc')}>
                    {' '}
                    &nbsp;▼
                  </a>
                  <a className={'nucleus-font-small ' + stateSortingStyles.startDateAsc} onClick={() => handleSortingMode('NoteDate:desc', 'NoteDate:asc')}>
                    &nbsp;▲
                  </a>
                </th>
                <th className="table-col-10 left-align">
                  <span className="nucleus-table-header-medium">{`Patient`}</span>
                  {/* <a class={ "nucleus-font-small " + stateSortingStyles.nameDesc } onClick={()=>handleSortingMode("nameAsc","nameDesc")}> &nbsp;▼</a>
                                    <a class={ "nucleus-font-small " + stateSortingStyles.nameAsc  } onClick={()=>handleSortingMode("nameDesc","nameAsc")} >&nbsp;▲</a> */}
                </th>
                <th className="table-col-38 left-align">
                  <span className="nucleus-table-header-medium">{'Note'}</span>
                </th>
                <th className="table-col-10 center-align">
                  <span className="nucleus-table-header-medium">{'User'}</span>
                  {/* <a class={ "nucleus-font-small " + this.state.sortSenderDesc } onClick={this.handleSortSenderDesc}> &nbsp;▲</a>
                                    <a class={ "nucleus-font-small " + this.state.sortSenderAsc }  onClick={this.handleSortSenderAsc} >&nbsp;▼</a> */}
                </th>
              </tr>
            </thead>

            {getTableRows()}
          </table>
        </div>
        <div className="fixed-action-btn">
          {callDataToExportRef.current && callDataToExportRef.current.length > 0 && (
            <CSVLink headers={csvFileHeadersRef.current} data={callDataToExportRef.current} filename={stateExportFileName + '.csv'} target="_blank">
              <a
                className={'btn-floating txt-white nucleus-font-small  nucleus-submit-btn-small'}
                style={{ width: 120, height: 35, textAlign: 'center', justifyContent: 'center', padding: 0 }}
              >
                Export to CSV
              </a>
            </CSVLink>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReportPatientNotes;
